import React from 'react';
import styled from 'styled-components';
import Card from '../../../components/Card';
import { Caption1 } from '../../../components/Typography';
import appConfig from '../../../../app-config';
import PayOnArrivalCard from '../../PaymentMethods/components/PayOnArrivalCard';

const Wrapper = styled(Card)`
  padding: 19px 16px;

  display: grid;
  grid-template-columns: auto auto 1fr;

  grid-gap: 32px;

  box-shadow: none;
  background-color: #f1f1f1;

  &:hover {
    background-color: ${(props) => props.theme.paymentCardColorHover};
    transition: all 0.25s ease;
  }
`;

const CardWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;
  align-items: center;
`;

const PaymentMethod = ({ paymentMethod }) => {
  const {
    method,
    last_four,
    card_type,
    expiry_date,
    balance,
    type,
  } = paymentMethod;

  const renderCardIconClassName = () => {
    switch (card_type) {
      case 'master':
      case 'mastercard':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/mc-symbol-opt-45-3-x%403x.png';
      case 'visa':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/Visa-POS-Graphic_visa_pos_fc.png';
      case 'discover':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/discover_logo.jpg';
      case 'amex':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/AXP_BlueBoxLogo_EXTRALARGEscale_RGB_DIGITAL_1600x1600.png';
    }
  };
  return (
    <>
      {method === 'Pay On Arrival' ? (
        <PayOnArrivalCard />
      ) : method === 'Apple Pay' ? (
        <Wrapper>
          <CardWrapper>
            <img
              src='https://s3.us-east-1.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/apple-pay-og-twitter.jpg'
              style={{ width: '50px' }}
              alt={card_type}
            />
            <Caption1>
              {type !== 'gift_card' ? `•••• ` : `${appConfig.giftCardName} *`}
              {last_four}
            </Caption1>
          </CardWrapper>
          <Caption1>
            {expiry_date &&
              `EXP ${expiry_date.substring(5, 7)}/${expiry_date.substring(
                2,
                4
              )}`}
            {type === 'gift_card' && `$${balance}`}
          </Caption1>
        </Wrapper>
      ) : method === 'Google Pay' ? (
        <Wrapper>
          <CardWrapper>
            <img
              src='https://s3.ca-central-1.amazonaws.com/assets.dev.smoothpay.com/smoothpay/google-icon.png'
              style={{ height: '30px', marginRight: '4px' }}
              alt={card_type}
            />
            <Caption1>
              {type !== 'gift_card' ? `•••• ` : `${appConfig.giftCardName} *`}
              {last_four}
            </Caption1>
          </CardWrapper>
          <Caption1>
            {expiry_date &&
              `EXP ${expiry_date.substring(5, 7)}/${expiry_date.substring(
                2,
                4
              )}`}
            {type === 'gift_card' && `$${balance}`}
          </Caption1>
        </Wrapper>
      ) : (
        <Wrapper>
          <CardWrapper>
            {card_type !== 'gift_card' ? (
              <img
                src={renderCardIconClassName()}
                style={{ width: '50px' }}
                alt={card_type}
              />
            ) : (
              <i className='fas fa-gift-card' style={{ fontSize: '26px' }} />
            )}
            <Caption1>
              {type !== 'gift_card' ? `•••• ` : `${appConfig.giftCardName} *`}
              {last_four}
            </Caption1>
          </CardWrapper>
          <Caption1>
            {expiry_date &&
              `EXP ${expiry_date.substring(5, 7)}/${expiry_date.substring(
                2,
                4
              )}`}
            {type === 'gift_card' && `$${balance}`}
          </Caption1>
        </Wrapper>
      )}
    </>
  );
};

export default PaymentMethod;
